module.exports = "<ng-content></ng-content>\n"


//////////////////
// WEBPACK FOOTER
// /vercel/path0/src/app/core/components/widget/widget.component.html
// module id = ../../../../../src/app/core/components/widget/widget.component.html
// module chunks = main